import CircularProgress from '@material-ui/core/CircularProgress'
import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

export const styles = theme => ({
  root: {
    progressWrapper: 20,
    textAlign: 'center',
  },
  progress: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(6),
  },
})

const ProgressLoader = ({
  classes, className: classNameProp, color, size
}) => {
  const className = classNames(classes.root, classNameProp)
  const colorIsHex = color && color.charAt(0) === '#'
  const colorProp = color && !colorIsHex ? color : 'primary'
  const colorStyle = color && colorIsHex ? { color } : null

  return (
    <div className={className}>
      <CircularProgress
        className={classes.progress}
        size={size || 40}
        color={colorProp}
        style={colorStyle}
      />
    </div>
  )
}

ProgressLoader.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
}

ProgressLoader.defaultProps = {}

export default withStyles(styles)(ProgressLoader)



// WEBPACK FOOTER //
// ./src/components/atoms/ProgressLoader.js